import {QueryResultType, useBenchlingQuery} from 'graphql-client/BenchlingQuery';
import {
  AllTagSchemasQuery,
  AllTagSchemasQuery_tagSchemas_TagSchemaNode as TagSchemaGQL,
} from 'registry/graphql/__generated/AllTagSchemasQuery';
import {ALL_TAG_SCHEMAS_QUERY} from 'registry/graphql/AllTagSchemasQuery';

export function useAllTagSchemas(): Array<TagSchemaGQL> | null {
  const tagSchemasResult = useBenchlingQuery<AllTagSchemasQuery>(ALL_TAG_SCHEMAS_QUERY);

  if (tagSchemasResult.type !== QueryResultType.SUCCESS) {
    return null;
  } else {
    return tagSchemasResult.data.tagSchemas;
  }
}
